import React from 'react';
import Slider from 'react-slick';
import Div from '../Div';
import Post from '../Post';
const postData = [
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443121/iz6iezwme6qks6zal3eq.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443124/iydqkdjvolnuasewltco.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443126/r4jgo7qzgl1gqseedmny.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443126/j2n8elep7luslxqzslum.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443124/xiokpq6cf22nvcqx53gw.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443124/jd1ziknf8j811vktvxln.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443124/elqvkrcgvcbovffqh6hd.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443121/xzye6xvvghdbzgtvmpou.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  {
    // url: '/blog/blog-details',
    src: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443121/jnrh417kxkwwzzvmyxs5.png',
    alt: 'Post',
    // date: '10 Feb 2022',
    // title: 'Artistic mind will be great for creation anything',
  },
  // {
  //   // url: '/blog/blog-details',
  //   src: '/images/g11.png',
  //   alt: 'Post',
  //   // date: '10 Feb 2022',
  //   // title: 'Artistic mind will be great for creation anything',
  // },
];

export default function PostSlider() {
  /** Slider Settings **/
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-24">
      {postData.map((item, index) => (
        <Div key={index}>
          <Post
            url={item.url}
            src={item.src}
            alt={item.alt}
            date={item.date}
            title={item.title}
          />
        </Div>
      ))}
    </Slider>
  );
}
